import React, { useCallback, useRef, useState } from 'react';
import './FAQ.scss';
import { IQuestionAnswer } from '../../types/content';
import { adobeTrack } from '../../utils';

interface IFAQItem {
  item: IQuestionAnswer;
}

interface IChevron {
  className: string;
  width: number;
  fill: string;
}

const Chevron = (props: IChevron) => {
  return (
    <svg className={props.className} width={props.width} viewBox="0 0 320 512">
      <path
        fill={props.fill}
        d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
      />
    </svg>
  );
};

const FAQItem = ({ item }: IFAQItem) => {
  const [setActive, setActiveState] = useState(false);
  const [setHeight, setHeightState] = useState('0px');
  const [rotationClass, setRotationClass] = useState('accordion_icon');

  const content = useRef(null);

  const toggleOpen = useCallback(() => {
    setActiveState(!setActive);
    setHeightState(setActive ? '0px' : `${content.current.scrollHeight}px`);
    setRotationClass(setActive ? 'accordion_icon' : 'accordion_icon rotate');
  }, [setActive]);

  const accordionClick = () => {
    toggleOpen();
    adobeTrack(item.tracking);
  };

  return (
    <div>
      {/*Div for the accordion question*/}
      <div
        className={`accordion ${setActive && 'active'}`}
        onClick={() => accordionClick()}
      >
        <p className="accordion_question">{item.question}</p>
        <Chevron className={`${rotationClass}`} width={10} fill={'#d3d3d3'} />
      </div>
      {/*Div for the accordion answer*/}
      <div
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className={'accordion_content'}
      >
        <p
          className="accordion_answer"
          dangerouslySetInnerHTML={{ __html: item.answer }}
        />
      </div>
    </div>
  );
};

export default FAQItem;
